import { render } from "./Temp.vue?vue&type=template&id=65570d50"
import script from "./Temp.vue?vue&type=script&lang=js"
export * from "./Temp.vue?vue&type=script&lang=js"

import "./Temp.vue?vue&type=style&index=0&id=65570d50&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__